module.exports = __webpack_public_path__ + "static/media/life-preserver.4f3f7088.svg";